export type DataGridRef = {
  refreshData?: VoidFunction;
  isLoading?: boolean;
};
